(function($) {
  var map;
  module.exports = function(coords, center, pinarray, zoomNumber){

    var styles = require("./gmapsStyles");
    //------- Google Maps ---------//

    // Creating a LatLng object containing the coordinate for the center of the map
    if(Modernizr.mq('only all and (max-width: 720px)') && zoomNumber){
      zoomNumber -= 1;
    }
    var latlng,
        geocoder,
        zoomLevel = (zoomNumber)? zoomNumber : 16,
        image,
        darkImage;

    if(center){
      latlng = new google.maps.LatLng(center[0], center[1]);
    } else {
      latlng = new google.maps.LatLng(51.52200,-0.04900);
    }


    // Creating an object literal containing the properties we want to pass to the map
    var options = {
      zoom: zoomLevel, // This number can be set to define the initial zoom level of the map
      center: latlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP, // This value can be set to define the map type ROADMAP/SATELLITE/HYBRID/TERRAIN
      disableDefaultUI: true
    };
    // Calling the constructor, thereby initializing the map
    map = new google.maps.Map(document.getElementById('gmaps-target'), options);

    if(typeof styles !== 'undefined'){
      map.setOptions({
        "styles": styles
      });
    }

    map.setOptions({
       draggable: false,
       scrollwheel: false,
       minZoom: 3
    });

    var mouseTimeout,
        activeTimeout = false;

    google.maps.event.addListener(map, 'click', function(){
      map.setOptions({
        draggable: true,
        scrollwheel: true
      });
      activeTimeout = false;
    });

    google.maps.event.addListener(map, 'mouseout', function(){
      clearTimeout(mouseTimeout);
      map.setOptions({
        draggable: false,
        scrollwheel: false
      });
    });

    // Define Marker properties
    if(pinarray){
      image = new google.maps.MarkerImage($('#gmaps-target').data('pin'),
        // This marker is 129 pixels wide by 42 pixels tall.
        new google.maps.Size(pinarray.imgwidth, pinarray.imgheight),
        // The origin for this image is 0,0.
        new google.maps.Point(0,0),
        // The anchor for this image is the base of the flagpole at 18,42.
        new google.maps.Point(pinarray.pointx, pinarray.pointy),

        new google.maps.Size(pinarray.width, pinarray.height)
      );

      darkImage = new google.maps.MarkerImage($('#gmaps-target').data('pindark'),
        // This marker is 129 pixels wide by 42 pixels tall.
        new google.maps.Size(pinarray.imgwidth, pinarray.imgheight),
        // The origin for this image is 0,0.
        new google.maps.Point(0,0),
        // The anchor for this image is the base of the flagpole at 18,42.
        new google.maps.Point(pinarray.pointx, pinarray.pointy),

        new google.maps.Size(pinarray.width, pinarray.height)
      );
    } else {
      image = new google.maps.MarkerImage($('#gmaps-target').data('pin'),
        // This marker is 129 pixels wide by 42 pixels tall.
        new google.maps.Size(160, 194),
        // The origin for this image is 0,0.
        new google.maps.Point(0,0),
        // The anchor for this image is the base of the flagpole at 18,42.
        new google.maps.Point(40, 97),

        new google.maps.Size(80, 97)
      );
    }

    // Add Marker
    var markers = [];
    if(coords){
      for (var i = coords.length - 1; i >= 0; i--) {
        if(coords[i][3] && coords[i][3].indexOf("sale") > -1){
          markimg = darkImage;
        } else {
          markimg = image;
        }
        markers[i] = new google.maps.Marker({
          position: new google.maps.LatLng(coords[i][0],coords[i][1]),
          map: map,
          icon: markimg, // This path is the custom pin to be shown. Remove this line and the proceeding comma to use default pin
          optimized: true
        });
        if(coords[i][2]){
          markers[i].propertyId = coords[i][2];
        }
      }
    } else {
      markers[0] = new google.maps.Marker({
        position: new google.maps.LatLng(51.52128,-0.04885),
        map: map,
        icon: image, // This path is the custom pin to be shown. Remove this line and the proceeding comma to use default pin
        optimized: true
      });
    }

    if($('#gmaps-target').hasClass('openblank')){
      $('#gmaps-target').on('click', function(){
        window.open('http://maps.google.com/maps?q='+coords[0][0]+','+coords[0][1]+'&z=16', '_blank');
      });
    }

    return map;
  };

})(jQuery);



/*****************
 ** WEBPACK FOOTER
 ** ./dev/js/modules/gmaps.js
 ** module id = 11
 ** module chunks = 1
 **/